module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "alert"
  }, [_c('div', {
    staticClass: "alertWrapper"
  }, [_c('div', {
    staticClass: "alertInfo"
  }, [_vm._v(_vm._s(_vm.info))]), _vm._v(" "), _c('div', {
    staticClass: "btnWrap"
  }, [_c('span', {
    on: {
      "click": _vm.confirm
    }
  }, [_vm._v("确定")]), _vm._v(" "), _c('span', {
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v("取消")])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-61b92624"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/alert/alert.vue
// module id = 272
// module chunks = 1